import { SuspensionAcknowledgementConfig } from '../@types/common.types';
import { SuspensionReason } from '../@types/shared.types';
import { SUSPENSION_SETTINGS } from '../constants/common.constants';

interface Suspendable {
    suspensionReason?: SuspensionReason | null;
    suspensionDetails?: { reason?: SuspensionReason | null } | null;
}

/** `suspensionDetails.reason` is the source of truth; the flat field is a fallback. */
export const getSuspensionReason = (user?: Suspendable | null): SuspensionReason | null =>
    user?.suspensionDetails?.reason ?? user?.suspensionReason ?? null;

/** Only reasons configured with an `acknowledgement` use the missed-session flow. */
export const getAcknowledgementConfig = (
    reason?: SuspensionReason | null
): SuspensionAcknowledgementConfig | undefined =>
    reason ? SUSPENSION_SETTINGS[reason]?.acknowledgement : undefined;
